import React, {useState, useEffect, useRef, useContext, useCallback} from 'react';
import useKeyPress from '../../../hooks/useKeyPress';
import {numbers, specialCharTextNumbers} from '../../views/textNumber-input/text-number';
import TextNumberEntryView from '../../views/textNumberEntryView';
import NumberView from '../../views/numberTNView';
import MenuContext from '../../../context/menuContext';
import D2TN from './d2TN';
import K2TN from './k2TN';

function K1TN({initiallyDisableKeypress}) {
  const [value, setValue] = useState(10);
  const {setDisableMenu, onComponent} = useContext(MenuContext);

  const onRightHold = useCallback(() => {
    setDisableMenu(true);
    onComponent(<K2TN initiallyDisableKeypress />);
    setTimeout(() => setDisableMenu(false), 500);
  }, [value]);

  return (
    <NumberView
      chars={numbers}
      focus={6}
      onChange={v => setValue(v)}
      defaultKey1={2}
      defaultKey2={2}
      defaultKey3={2}
      defaultKey4={2}
      defaultKey5={2}
      defaultKey6={3}
      defaultKey7={2}
      defaultKey8={2}
      defaultKey9={2}
      defaultKey10={12}
      defaultKey11={2}
      defaultKey12={2}
      onSave={onRightHold}
      onLeftHold={() => onComponent(<D2TN />)}
      title="Set K1"
      caption="Enter K1 from Sensor Tag:"
      left="Hold to Cancel"
      right="Hold to Save"
      initiallyDisableKeypress={initiallyDisableKeypress}
    />
  );
}

export default K1TN;
